var React = require('react');

function Seats (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#2886A2","cx":"16","cy":"16","r":"16","key":0}),React.createElement("g",{"fill":"#FFF","fillRule":"nonzero","key":1},React.createElement("path",{"d":"M18 13h-5-1l-1 2v4l1 1v7l1 1h5l1-1v-6l1-1v-5-2h-2zM16 11c2 0 3-1 3-3 0-1-1-3-3-3s-3 2-3 3c0 2 1 3 3 3z"}))]));
}

Seats.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Seats;

Seats.default = Seats;
